import "./app.css";
import coin from "./images/coin.png";
import btnImg from "./images/button.png";

function App() {
  return (
    <div className="App">
      <div
        style={{
          width: "100%",
          height: "50%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img src={coin} alt="coin" className="App__coinImg" />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <h1 className="App__heading">Легкие деньги</h1>
        <h2 className="App__heading-sub">за простые задачи</h2>
        <a
          className="App__download"
          target="_blank"
          rel="noreferrer"
          href="https://redirect.appmetrica.yandex.com/serve/99557750681438243"
        >
          <img src={btnImg} alt="get it on Google Play" />
        </a>
      </div>
    </div>
  );
}

export default App;
